"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtag = exports.extractGoogleTagsForUrl = exports.getGoogleTagsPaths = void 0;
const utils_1 = require("@obvio/utils");
const locales_1 = require("./locales");
const env_1 = require("../env");
function reduceTags(acc, tag) {
    const cleanTag = tag.trim();
    if (cleanTag === '') {
        return acc;
    }
    if (cleanTag.startsWith('GTM-')) {
        if (acc.gtm) {
            throw new Error('Only one GTM tag is allowed');
        }
        return Object.assign(Object.assign({}, acc), { gtm: cleanTag });
    }
    return Object.assign(Object.assign({}, acc), { gtags: [...acc.gtags, cleanTag] });
}
exports.getGoogleTagsPaths = (0, utils_1.memoize)(() => {
    const tagsEnv = (0, env_1.obvioEnv)().OBVIO_PUBLIC_GOOGLE_TAGS;
    if (!tagsEnv) {
        return { '*': { gtags: [] } };
    }
    let parsed;
    try {
        parsed = JSON.parse(tagsEnv);
    }
    catch (_a) {
        parsed = { '*': tagsEnv };
    }
    return Object.fromEntries(Object.entries(parsed).map(([k, v]) => [
        k,
        v.split(',').reduce(reduceTags, { gtags: [] }),
    ]));
});
function extractGoogleTagsForUrl(pathname) {
    const _a = (0, exports.getGoogleTagsPaths)(), { '*': all } = _a, rest = __rest(_a, ['*']);
    const { gtm, gtags } = rest[(0, locales_1.delocalizeRoute)(pathname)] || all || { gtags: [] };
    return { gtm, gtags };
}
exports.extractGoogleTagsForUrl = extractGoogleTagsForUrl;
exports.gtag = {
    pageview(url) {
        var _a;
        const { gtm, gtags } = extractGoogleTagsForUrl(window.location.pathname);
        if (gtm) {
            ;
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'pageview', page: { url } });
        }
        gtags.forEach((tag) => {
            var _a, _b;
            ;
            (_b = (_a = window).gtag) === null || _b === void 0 ? void 0 : _b.call(_a, 'config', tag, { page_path: url });
        });
    },
    event(_a) {
        var _b;
        var { action } = _a, data = __rest(_a, ["action"]);
        const { gtm, gtags } = extractGoogleTagsForUrl(window.location.pathname);
        if (gtm) {
            ;
            (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push(Object.assign({ event: action }, data));
        }
        if (gtags.length > 0) {
            ;
            window.gtag('event', action, data);
        }
    },
};
